import mirrorCreator from 'mirror-creator';

const actionTypes = mirrorCreator(['UPDATE_PLATFORM']);

export default actionTypes;
